import useQuery from 'components/useQuery'
import { api } from 'api'
import { useEffect } from 'react'
import { useToast } from '@chakra-ui/react'

export const useUpdateUser = (id) => {
  const toast = useToast()
  const {
    isError,
    isLoading,
    isSuccess,
    request,
    error,
  } = useQuery((data) => api.admin.updateUser(id, data))

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Ошибка',
        description: error.response?.data?.errorText,
        status: 'error',
      })
    }
  }, [isError])

  useEffect(() => {
    if (isSuccess) {
      toast({
        title: 'Готово',
        description: 'Пользователь успешно обновлен',
        status: 'success'
      })
    }
  }, [isSuccess])

  return {
    updateUser: request,
    isLoadingUpdate: isLoading
  }
}
